// @ts-nocheck
import { utils as SolyticsUtils } from '@nuva-org/solytics-frontend';

import { clearAllStorage } from '../commonAuthUtils';
import API_ENDPOINTS from '../../const/ApiEndPoints';
import SwalToast from '../../components/Common/swalToast';

export const hostNeedsOrg = (reqUrl) => {
  return API_ENDPOINTS.HOSTS_NEEDS_TOKEN.includes(
    new URL(reqUrl).host.split(':')[0]
  );
};

export const showApplicationLauncher = () => {
  try {
    return JSON.parse(localStorage.getItem('REALM_CONFIG'))?.launcher || false;
  } catch {
    return false;
  }
};

export const handleInvalidRealm = () => {
  clearAllStorage();
  SwalToast({
    icon: 'error',
    title: 'Please provide valid organization name.',
  });
};

/*
 * Extracts authentication parameters from URL (both legacy and secure formats)
 * @param {URLSearchParams} params - URL search parameters
 * @returns {Object} Authentication parameters object
 */
export const extractAuthParams = (params) => {
  const encodedAuth = params.get('auth');

  if (encodedAuth) {
    const decodedAuth = SolyticsUtils.decodeURLParams(encodedAuth);
    if (decodedAuth) {
      return decodedAuth;
    }
  }
  // TODO: Remove legacy parameter support once secure params are fully adopted.
  const legacyParams = {
    realm_id: params.get('realm_id') || params.get('realmId'),
    access_token: params.get('access_token'),
    refresh_token: params.get('refresh_token'),
    session_id: params.get('session_id'),
    device_id: params.get('device_id'),
  };
  return legacyParams;
};
